<div
  class="atn-ds-stepper-item"
  [class.atn-ds-stepper-item--selected]="isActive"
  (click)="clickHandler($event)"
>
  <ng-content></ng-content>
</div>
